<template name="component-name">
  <div v-if="spinning" class="loading-content">
    <img src="../assets/imgs/loading.png" alt="" />
    <span>{{ TLang('加载中', 'result') }}...</span>
  </div>
</template>

<script>
export default {
  props: ["spinning"]
};
</script>

<style lang="less">
.loading-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 400px;
  & > img {
    width: 33px;
    height: 33px;
    transform: rotate(0deg);
    animation: imgRotate 2s linear infinite;
  }
  & > span {
    font-size: 12px;
  
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
    line-height: 38px;
  }
}
@keyframes imgRotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
